export default "__VITE_ASSET__CikvHeKF__"